var EmptyError = (function () {
    function EmptyError() {
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    }
    return EmptyError;
})();
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/EmptyError.js
 ** module id = 100
 ** module chunks = 1
 **/